<template>
  <div v-if="getSelectedOffer?.props !== undefined">
    <div class="mt-24" v-for="(param, index) in getProperties" :key="index">
      <template
        v-if="
          Object.keys(param.values).length > 0 &&
          Object.keys(getAllOffersProp[index].values).length > 1
        "
      >
        <div class="grid-row d-flex_between">
          <div class="grid-col color-gray">{{ param.name }}:</div>
        </div>

        <div class="grid-row grid-row_sm d-flex_wrap mt-8">
          <div
            class="grid-col pt-8"
            v-for="(value, id) in param.values"
            :key="id"
          >
            <ParamButton
              :checked="isActiveParam(index, value.id)"
              :name="availability ? index + '_availability' : index"
              :value="value.id"
              :object="value"
            >
              <template v-slot:param>
                {{ value.name }}
                <span
                  v-if="
                    param.name === 'Полнота' &&
                    getSelectedOffer.props?.polnota?.value?.number !== undefined
                  "
                  class="d-block fs-12 fw-light fs-sm-10 mt-2"
                  >{{ getSelectedOffer.props?.polnota?.value?.number }} см</span
                >
              </template>
            </ParamButton>
          </div>
        </div>
      </template>

      <div
        v-if="Object.keys(getAllOffersProp[index].values).length == 1"
        class="grid-row d-flex_between"
      >
        <div class="grid-col color-gray">
          {{ param.name }}:
          <span
            class="grid-col pt-8"
            v-for="(value, id) in param.values"
            :key="id"
          >
            {{ value.name }}
            <span
              v-if="
                param.name === 'Полнота' &&
                getSelectedOffer.props?.polnota?.value?.number !== undefined
              "
              class="fs-12 fw-light fs-sm-10 mt-2"
              >({{ getSelectedOffer.props?.polnota?.value?.number }} см)</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParamButton from "@/pages/product_card/components/ParamButton/ParamButton.vue";
// import PopupFullness from "@/pages/product_card/components/Popups/PopupFullness";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

export default {
  name: "PropertiesBlock",
  components: {
    ParamButton,
    // PopupFullness,
  },
  props: {
    availability: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const store = useProductStore();

    return {
      store,
    };
  },
  mounted() {
    let prop = this.getProperties;

    for (let key in prop) {
      this.store.isSelected[key] = Object.keys(prop[key].values).length < 2;
    }
  },
  computed: {
    ...mapState(useProductStore, [
      "getOffersForProduct",
      "getSelectedProduct",
      "getSelectedOffer",
      "getSelectedSize",
      "isActiveParam",
      "getProperties",
      "getAllOffersProp",
    ]),
  },
};
</script>
